import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["running-in-the-heat"]!;

export function Body() {
  return (
    <>
      <p>
        Warm weather makes running harder, and most runners feel it. Two studies help answer how
        much heat costs on race day and what you can do to get used to it.
      </p>

      <h2>What the researchers did</h2>
      <p>
        One study collected results and weather data from seven American and Canadian marathons
        over up to 36 years. The researchers grouped the races by heat stress, measured as wet
        bulb globe temperature, which combines temperature, humidity, sun and wind, from 5 to 25
        °C.
      </p>
      <p>
        A meta-analysis from 2016 reviewed 96 studies of heat adaptation, where people train
        repeatedly in the heat to get used to it.
      </p>

      <h2>What they found</h2>
      <p>
        Marathon times got progressively slower as heat stress increased. The fastest men were
        1.7 percent slower than the course record in the coolest conditions and 4.5 percent slower
        in the warmest. Slower runners lost more time than the fastest.
      </p>
      <p>
        Heat adaptation helped. Training in the heat for 7 to 14 days, the most common period,
        improved performance in the heat and lowered body temperature during exercise. Longer
        periods of more than 14 days gave the largest effect.
      </p>

      <h2>What it means for you</h2>
      <p>
        On a warm race day, adjust your goal pace and start more carefully. The warmer it is, and
        the longer you are out there, the more it matters.
      </p>
      <p>
        If your race is likely to be warm, spend one to two weeks or more training in warm
        conditions beforehand, for example by running at the warmest time of day. Drink, keep
        the effort controlled and stop if you feel dizzy or unwell.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        The marathon study shows how results changed with weather, not how much a single runner
        should slow down. Heat adaptation studies differ a lot in method, so the exact time
        needed is still uncertain.
      </p>

      <h2>How we use it</h2>
      <p>
        Pace targets in PX7 Training are based on normal conditions. On hot days, run by effort
        and breathing, and let the pace drop. Your log keeps what you actually ran.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Ely et al. (2007), Impact of weather on marathon-running performance.{" "}
          <a href="https://doi.org/10.1249/mss.0b013e31802d3aba">Medicine & Science in Sports & Exercise</a>.
        </li>
        <li>
          Tyler et al. (2016), The effects of heat adaptation on physiology, perception and
          exercise performance in the heat: a meta-analysis.{" "}
          <a href="https://doi.org/10.1007/s40279-016-0538-5">Sports Medicine</a>.
        </li>
      </ul>
    </>
  );
}
